import { useQuery } from '@tanstack/react-query';

import { KEYS_QUERY } from 'common/constants';
import useService from 'common/hook/useService';
import { handleException } from 'modules/account/detail/helpers/utils';

import type { QsSuppliersResponse } from 'modules/quick-search/types';

interface Props {
  groupId?: number;
  page?: number;
  perPage?: number;
  enabled?: boolean;
}

/** UC2 — Danh sách HSNL NCC theo NMH (phân trang server-side qua meta KIOS). */
const useQuickSearchSuppliers = ({ groupId, page, perPage, enabled = true }: Props) => {
  const service = useService();

  return useQuery({
    queryKey: [KEYS_QUERY.qsSuppliers, groupId, page, perPage],
    queryFn: async (): Promise<QsSuppliersResponse | null> => {
      try {
        if (!service || !groupId) return null;
        return await service.QuickSearchController_getSuppliers({
          queries: { groupId, page, perPage },
        });
      } catch (error) {
        handleException(error);
        return null;
      }
    },
    enabled: !!service && !!groupId && enabled,
  });
};

export default useQuickSearchSuppliers;
